import { Text, Space } from '@bancobarigui/barihaus';
import type { AmostraCardData } from '../types';
import { formatarMoeda, getAreaDisplay } from '../utils';
import * as styles from '../styles';

interface AmostraInfoProps {
  amostra: AmostraCardData;
  metodologia?: string | undefined;
}

export function AmostraInfo({ amostra, metodologia }: AmostraInfoProps) {
  const { areaValue, label } = getAreaDisplay(amostra);
  const isAvaliando = amostra.identificacao === 'Avaliando';
  const isComparativoDireto = metodologia === 'Comparativo Direto de Mercado';

  // Idade aparente e vagas ficavam só no modal de edição; agora aparecem no card.
  // Terreno não tem nem idade nem garagem, então ficam de fora.
  const isTerreno = amostra.tipoImovel === 'Terreno';
  const idadeAparente = Number(amostra.idadeAparente) || 0;
  const quantidadeVagas = Number(amostra.quantidadeVagas) || 0;

  return (
    <div style={styles.infoContainerStyle}>
      <div style={styles.badgeContainerStyle}>
        <Text style={styles.getBadgeTextStyle(isAvaliando)}>
          {isAvaliando ? 'Imóvel Avaliando' : `Amostra ${amostra.identificacao}`}
        </Text>
      </div>

      <Text strong style={styles.titleStyle}>
        {amostra.endereco || `${amostra.tipoImovel} - ${amostra.identificacao}`}
      </Text>

      <Space split="•" size={8} style={styles.detailsStyle}>
        <Text type="secondary">
          {Number(areaValue || 0).toFixed(0)} m² {label}
        </Text>
        {!isComparativoDireto && !isTerreno && amostra.areaTerreno > 0 && (
          <Text type="secondary" className="hidden-mobile">
            {Number(amostra.areaTerreno || 0).toFixed(0)} m² Terreno
          </Text>
        )}
        {!isTerreno && idadeAparente > 0 && (
          <Text type="secondary">
            {idadeAparente} {idadeAparente === 1 ? 'ano' : 'anos'}
          </Text>
        )}
        {!isTerreno && quantidadeVagas > 0 && (
          <Text type="secondary">
            {quantidadeVagas} {quantidadeVagas === 1 ? 'vaga' : 'vagas'}
          </Text>
        )}
        <Text strong style={styles.valorStyle}>
          {formatarMoeda(amostra.valorTotal)}
        </Text>
      </Space>
    </div>
  );
}
